export const videoInfos = [
	{
		title: "FORMAT_AND_QUALITY",
		infos: ["INFO_ONE", "INFO_TWO", "INFO_THREE", "INFO_FOURTH"],
	},
	{
		title: "CONTENT",
		infos: ["INFO_ONE", "INFO_TWO", "INFO_THREE", "INFO_FOURTH", "INFO_FIFTH"],
	},
] as const;
